<div class="p-2" style="background-color: #333333; color: #ffcc00;">
  <h5 class="modal-header-label ml-2 mt-1"> {{'Session Timeout'}}</h5>
</div>
<div class="p-3 text-center" *ngIf="!logoutMsgDisplay">
  <div class="form-group">
    <span style="font-size: 30px;" class="pr-2 pt-2"><i class="fa fa-clock-o" aria-hidden="true"></i></span>
    <span style="font-size: 15px; font-family: ubuntu;">
      Your session will expire in
    </span>
  </div>

  <div class="form-group" style="font-size: 20px; font-family: ubuntu;">
    {{counter}} {{counter < 2 ? ' second' : ' seconds' }} </div>

      <div class="form-group mt-3" style="font-size: 14px; font-family: ubuntu; columns: #333333;">
        Please login again to continue.
      </div>
  </div>

  <div class="p-3 text-center" style="font-size: 15px; font-family: ubuntu; margin-top:70px;" *ngIf="logoutMsgDisplay">
    Logging out now...
  </div>

  <div class="p-3 text-right" *ngIf="!logoutMsgDisplay">
    <button class="btn btn-secondary" (click)="closeTimer()">Cancel</button>
  </div>